import type { RangeKey } from '@dataTypes/dashboard.types'
import type { ChairTimeDetailResult } from '@services/api/dashboard/chair-time.api'
import { getChairTimeConfig } from '@components/pages/Dashboard/Overview/dashboardOverview.mockData'
import { getOverviewChairTimeMetrics } from '@components/pages/Dashboard/Overview/overviewMetrics.mockData'
import {
  getChairTimeByPeriodRows,
  getChairTimeByProviderRows,
  getChairTimeChartConfig,
  getChairTimeKpi,
} from '@pages/Dashboard/ChairTimeDetail/chairTimeDetail.mockData'
import { rangeToPeriod } from '@utils/dashboardFinance.util'

export function buildChairTimeOverviewFromMock(range: RangeKey): {
  chairTime: ReturnType<typeof getChairTimeConfig>
  metrics: ReturnType<typeof getOverviewChairTimeMetrics>
} {
  const config = getChairTimeConfig(range)
  return {
    chairTime: config,
    metrics: getOverviewChairTimeMetrics(range),
  }
}

export function buildChairTimeDetailFromMock(
  range: RangeKey,
): ChairTimeDetailResult {
  const mockKpi = getChairTimeKpi(range)
  const byProvider = getChairTimeByProviderRows(range)
  const completedAppts = byProvider.reduce(
    (sum, row) => sum + row.completedAppts,
    0,
  )

  return {
    period: rangeToPeriod(range),
    periodStart: '',
    periodEnd: '',
    kpis: {
      ...mockKpi,
      completedAppts,
    },
    chart: getChairTimeChartConfig(range),
    byProvider: byProvider.map((row) => ({
      ...row,
      role: row.role,
    })),
    byPeriod: getChairTimeByPeriodRows(range),
  }
}
